import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgForOf } from '@angular/common';
import { CatalogListItemComponent } from '../catalog-list-item/catalog-list-item.component';
import { CatalogListItemResponse as CatalogItem } from '@medindex-webapi';

@Component({
  selector: 'app-catalog-section-list',
  templateUrl: './section-list.component.html',
  styleUrls: ['./section-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CatalogListItemComponent, NgForOf],
})
export class SectionListComponent {
  @Input() title = '';
  @Input() list: CatalogItem[] = [];

  trackBy(index: number, item: CatalogItem): number {
    return item.id;
  }
}
